import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import imageOne from "../../resource/hermitage/feature-plans/2.png";
import imageThree from "../../resource/hermitage/feature-plans/1.png";


import imageFour1 from '../../resource/hermitage/feature-plans/4.png'
import imageFive1 from '../../resource/hermitage/feature-plans/6.png'

import qrcode from '../../resource/donations/annual-sub/qr.png'
import imageSix from "../../resource/hermitage/feature-plans/3 (1).png";

import { Carousel } from "../Corousel/Carousel";

import data from "../../data/carouselData.json";

const FeaturePlans = () => {
    const navigate = useNavigate();
        const handleClick = (event) => {
            const pathMap = {
              featureplansrequest:"/featureplansrequest"
            };
        
            const path = event.currentTarget.id;
            const targetPath = pathMap[path];
        
            if (targetPath) {
              navigate(targetPath);
            }
          };
  return (
    <div className="featurePlans-page inside-pages">
    <div className="right-box">
      <img
        src={imageOne}
        alt="Right Top Image"
        className="right-image"
        width={300}
      />
    </div>

    <h1 className="font-main dark-gold p-4 mt-4">Future Plans
    </h1>
    <p className="h4 dark-gold p-4 mt-4">
    There are several future projects planned to enhance the auspiciousness and energy of the premises, thereby helping the Sangha and the community experience greater peace and tranquility:

    </p>
    <h1 className="font-main dark-gold p-4 mt-6 text-center">Project 01</h1>
    <p className="h4 dark-gold p-4 mt-6 text-bold">Planting a Sapling of the “Sri Maha Bodhi” Tree  
    </p>

    <p className="mt-5 h4 mb-4 p-4">
    This project is to plant a Sapling of Sri Maha Bodhi Tree at Central high area of the premises. The presence of a Bodhi Tree keeps the mind calm, and Its very essence encourages a mindfulness and stillness.

      </p>

      <p className="h4 dark-gold p-4 mt-6 text-bold">Constructing a Wooden Enclosure for the Bodhi Tree
      </p>
      <p className="mt-5 h4 mb-4 p-4">A wooden enclosure will be built around the Bodhi plant for its protection, along with a larger wooden podium designed to invite devotees to sit, reflect, and meditate.</p>

     <h1 className="font-second dark-gold p-4 mt-6 text-center">
        Project 01 - Photos
      </h1> 
    <div className=" mt-5 p-4 center">
      <div className=" mt-5">
        <Carousel data={data.feature1} />
      </div>

     
    </div>

    <h1 className="font-second dark-gold p-4 mt-6 text-center">
      Estimated Costs
      </h1>

      <div className="table-container2 h4 mt-5 p-4">
        <table>
          <thead>
            <tr>
              <th>Materials Needed</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            
              <tr >
                <td></td>
                <td></td>
              </tr>
           
          </tbody>
        </table>
      </div>


    <h1 className="font-main dark-gold p-4 mt-6 text-center">Project 02</h1>
    <p className="h4 dark-gold p-4 mt-6 text-bold">Building new Sangha Residence 

    </p>

    <p className="mt-5 h4 mb-4 p-4">
    A plan is in place to expand the Kuti complex to accommodate the growing Sangha community. This new establishment will feature a library and essential facilities to support the spiritual journey of up to ten Sangha members
      </p>

    
      <h1 className="font-second dark-gold p-4 mt-6 text-center">
        Project 02 - Photos
      </h1> 
    <div className=" mt-5 p-4 center">
      <div className=" mt-5">
        <Carousel data={data.feature2} />
      </div>

     
    </div>

    <h1 className="font-second dark-gold p-4 mt-6 text-center">
      Estimated Costs
      </h1>

      <div className="table-container2 h4 mt-5 p-4">
        <table>
          <thead>
            <tr>
              <th>Materials Needed</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            
              <tr >
                <td></td>
                <td></td>
              </tr>
           
          </tbody>
        </table>
      </div>



    <h1 className="font-main dark-gold p-4 mt-6 text-center">Project 03</h1>
    <p className="h4 dark-gold p-4 mt-6 text-bold">Caretaker Residence

    </p>

    <p className="mt-5 h4 mb-4 p-4">
    A plan is in place to construct a caretaker residence, equipped with all necessary amenities. The caretaker will be responsible for overseeing the ongoing management activities and attending to the daily needs of the Sangha

      </p>

    
      <h1 className="font-second dark-gold p-4 mt-6 text-center">
        Project 03 - Photos
      </h1> 
    <div className="mt-5 p-4 center">
      <div className=" mt-5">
        <Carousel data={data.feature3} />
      </div>

     
    </div>

    <h1 className="font-second dark-gold p-4 mt-6 text-center">
      Estimated Costs
      </h1>

      <div className="table-container2 h4 mt-5 p-4">
        <table>
          <thead>
            <tr>
              <th>Materials Needed</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            
              <tr >
                <td></td>
                <td></td>
              </tr>
           
          </tbody>
        </table>
      </div>


    <h1 className="font-main dark-gold p-4 mt-6 text-center">Project 04</h1>
    <p className="h4 dark-gold p-4 mt-6 text-bold">Establishing Meditation Venues Around the Pond

    </p>

    <p className="mt-5 h4 mb-4 p-4">
    The two existing ponds at the lower part of the premises will be transformed into serene and restful meditation venues. Wooden walking paths will be created around the ponds, and trees and shrubs will be planted to maintain a green and natural environment. Large benches will be added, inviting yogis to immerse themselves in outdoor retreats under a tranquil canopy.

      </p>

    
      <h1 className="font-second dark-gold p-4 mt-6 text-center">
        Project 04 - Photos
      </h1> 
    <div className=" mt-5 p-4 center">
      <div className=" mt-5">
        <Carousel data={data.feature4} />
      </div>

     
    </div>

   

    
      <h1 className="font-second dark-gold p-4 mt-6 text-center">
      Estimated Costs
      </h1>

      <div className="table-container2 h4 mt-5 p-4">
        <table>
          <thead>
            <tr>
              <th>Materials Needed</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            
              <tr >
                <td></td>
                <td></td>
              </tr>
           
          </tbody>
        </table>
      </div>

      <div className='btn-group2 mt-6'>
              <img src={imageFour1} alt="Right Top Image" width={300} />
              <img src={imageFive1} alt="Right Top Image" width={300} />
          </div>

         
    
          <div className="p-4 mt-6 text-center">
          <div className="mt-6 calander-box align-item-center">
                  <div className="c-details text-left">
                      <h2 className='intro-text '>Futher More Details : </h2>
                      <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                      <p className="font-p">Mr Gamini : 0422 069 359</p>
                      <p className="font-p">WhatsApp : 0422 069 359</p>
                      <p className="font-p">E-mail : info@bvp.org.au</p>
                  </div>
                  <div className="d-button">
                  <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id="featureplansrequest"
          onClick={handleClick}
          className="curser-pointer"
        />
                    </div>
              </div>
              </div>

              <div className="bottom-box mt-6">
              <img src={imageThree} alt="bottom-image"  width={600} />
          </div>
   

    
  </div>
  )
}

export default FeaturePlans